<template>
  <div class="content">
    <div class="container">
      <top-facts />
    </div>
    <div class="container">
      <top-breweries />
    </div>
    <div class="container">
      <top-drinkers />
    </div>
    <div class="container">
      <top-favorites />
    </div>
  </div>
</template>
<script>
import TopFacts from './facts/TopFacts'
import TopFavorites from './facts/TopFavorites'
import TopDrinkers from './facts/TopDrinkers'
import TopBreweries from './facts/TopBreweries'

export default {
  components: {TopFacts, TopFavorites, TopDrinkers, TopBreweries}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../assets/styles/config.scss';
  .container + .container {
    margin-top: 40px;
  }
  .content {
    .brewery {
      font-weight: bold;
      cursor: pointer;

      .expander {
        font-style: normal;
        margin-right: 10px;
        color: $primary;

        &.expand {
          &::before {
            content: '+';
          }
        }
        &.expanded {
          &::before {
            content: '-';
          }
        }
      }
    }
    .brewery__beers {
      display: none;
      &.is-visible {
        display: table-row;
      }
      &--td {
        display: table-cell;
      }
      .beers-data {
        padding: 30px;
      }
      .beers-data__header {
        border-bottom: 2px solid #ccc;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Facts.vue?e00d1564